import type { Point } from '../SurfaceBase';

export const BBOX_PADDING = 20;
export const STEM_LENGTH = 30;

export const ARROW_SIZE = 20;
export const ARROW_ANGLE = Math.PI / 2;
export const ARROW_HEIGHT = ARROW_SIZE * Math.sin(ARROW_ANGLE / 2);
export const ARROW_WIDTH = ARROW_SIZE * Math.cos(ARROW_ANGLE / 2);

export const ZOOM_THRESHOLD = 14;

export function getArrowPath() {
  const path = new Path2D();
  path.moveTo(-ARROW_WIDTH / 2, ARROW_HEIGHT);
  path.lineTo(0, 0);
  path.lineTo(ARROW_WIDTH / 2, ARROW_HEIGHT);

  return path;
}

export function getArrowScale(zoom: number): number {
  return (zoom / ZOOM_THRESHOLD) ** 4;
  // return Math.pow(2, zoom - 14);
}

export function getAnchorPoint(p1: Point, p2: Point): Point {
  return {
    x: p1.x - STEM_LENGTH,
    y: p1.y,
  };
}
